import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import { isTemperatureSafe, formatTemperature } from 'models/kiosks/helpers';

// Icons
import TemperatureIcon from 'assets/icons/temperature.svg';

// Styles
import './temperature-styles.scss';


const Temperature = ({
  temperature,
}) => {
  return <div className={`c-KioskListItemTemperature ${temperature?.isSafe === false && 'c-KioskListItemTemperature-red'}`}>
    {
      <img alt='tmp' className='temperature-image' src={TemperatureIcon}/>
    }
    {
      temperature?.fahrenheit?.formatted || 'N/A'
    }
  </div>;
};

export default observer(Temperature);
